import { Box } from '@chakra-ui/react';

type StatusType = 'info' | 'success' | 'warning' | 'error' | 'disabled';

interface StatusBadgeProps {
  status: StatusType;
  children: React.ReactNode;
}

const STATUS_COLORS: Record<StatusType, { bg: string; color: string }> = {
  info: { bg: 'blue.50', color: 'blue.600' },
  success: { bg: 'green.50', color: 'green.600' },
  warning: { bg: 'orange.50', color: 'orange.600' },
  error: { bg: 'red.50', color: 'red.600' },
  disabled: { bg: 'gray.200', color: 'gray.600' },
};

const StatusBadge = ({ status, children }: StatusBadgeProps) => {
  const colors = STATUS_COLORS[status];

  return (
    <Box
      p="8px 16px"
      bg={colors.bg}
      borderRadius="md"
      fontSize="sm"
      color={colors.color}
      w="100%"
      textAlign="center"
    >
      {children}
    </Box>
  );
};

export default StatusBadge;
